import { render, staticRenderFns } from "./sportsRule.vue?vue&type=template&id=445978ac"
import script from "./sportsRule.vue?vue&type=script&lang=js"
export * from "./sportsRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports